export default __webpack_public_path__ + "static/media/agenday-and-screenplay.062abb10.svg";